{
	"savedCartDetails": {
		"cartName": "Naam",
		"cartDescription": "Description",
		"cartId": "ID",
		"dateSaved": "Datum opgeslagen",
		"items": "Items",
		"quantity": "Quantity",
		"total": "Totaal",
		"editSavedCart": "Edit Saved Cart",
		"deleteSavedCart": "Verwijderen",
		"addSelectedItems": "Add selected items",
		"emptyCartItems": "Empty Cart Items"
	},
	"savedCartList": {
		"savedCarts": "Saved Carts ({{count}})",
		"cartName": "Naam",
		"cartId": "Id",
		"dateSaved": "Datum opgeslagen",
		"cartDescription": "Description",
		"quantity": "Qty",
		"total": "Totaal",
		"actions": "Acties",
		"makeCartActive": "Winkelwagen actief maken",
		"notFound": "Geen opgeslagen winkelwagens gevonden",
		"swapCartNoActiveCart": "Bestaande winkelwagen is succesvol geactiveerd door {{cartName}}.",
		"swapCartWithActiveCart": "Bestaande winkelwagen is succesvol geactiveerd door {{cartName}}. Ihre vorherigen Artikel wurden in einem Warenkorb {{previousCartName}} gespeichert."
	},
	"savedCartCartPage": {
		"messages": {
			"cartSaved": "Uw winkelwagenitems zijn met succes opgeslagen voor later in de \"{{cartName}}\" cart"
		}
	},
	"savedCartDialog": {
		"saveForLater": "bewaar voor later",
		"itemsSavedForLater": "Alle artikelen in uw winkelwagen worden bewaard voor later",
		"savedCartName": "Naam",
		"savedCartDescription": "omschrijving",
		"optional": "optioneel",
		"charactersLeft": "tekens over: {{count}}",
		"cancel": "Afbreken",
		"save": "Overnemen",
		"followingCartDelete": "De volgende opgeslagen winkelwagen wordt verwijderd",
		"delete": "Verwijderen",
		"deleteCartSuccess": "Winkelwagen succesvol verwijderd",
		"editCartSuccess": " Winkelwagen is succesvol bewerkt",
		"editSavedCart": "Bewerken",
		"deleteSavedCart": "Delete Saved Cart",
		"name": "Naam",
		"id": "ID",
		"description": "omschrijving",
		"quantity": "QTY",
		"total": "Totaal"
	},
	"addToSavedCart": {
		"savedCarts": "Opgeslagen winkelwagentjes",
		"saveCartForLater": "Winkelwagen aanmaken"
	}
}
